import { testimonials } from "@/mocks/comics";

export default function ComicComments() {
  const leftCol = testimonials.filter((_, i) => i % 3 === 0);
  const midCol = testimonials.filter((_, i) => i % 3 === 1);
  const rightCol = testimonials.filter((_, i) => i % 3 === 2);

  return (
    <section className="w-full py-14 md:py-20 bg-background-100">
      <div className="w-full px-4 md:px-6">
        <div className="mb-10 md:mb-14">
          <span className="inline-block text-xs font-medium text-accent-500 bg-accent-100 px-3 py-1 rounded-full mb-3 whitespace-nowrap">
            读者热评
          </span>
          <h2 className="text-2xl md:text-3xl lg:text-4xl font-black text-foreground-950 leading-tight"
            style={{ fontFamily: "var(--font-heading)" }}>
            大家对这部作品的<br className="hidden sm:block" />真实反馈
          </h2>
        </div>

        <div className="grid grid-cols-1 sm:grid-cols-3 gap-4 md:gap-6">
          {[leftCol, midCol, rightCol].map((col, colIdx) => (
            <div key={colIdx} className="flex flex-col gap-4 md:gap-6">
              {col.map((item) => (
                <div
                  key={item.id}
                  className="bg-background-50 border border-background-200/70 rounded-lg p-4 md:p-5"
                >
                  <div className="flex items-center gap-3 mb-3">
                    <img
                      src={item.avatar}
                      alt={item.name}
                      className="w-10 h-10 md:w-11 md:h-11 rounded-full object-cover"
                    />
                    <div>
                      <p className="text-sm font-semibold text-foreground-900 whitespace-nowrap">
                        {item.name}
                      </p>
                      <p className="text-xs text-foreground-400 whitespace-nowrap">
                        @{item.name.replace(/\s/g, "").toLowerCase()}
                      </p>
                    </div>
                  </div>
                  <p className="text-sm text-foreground-600 leading-relaxed">
                    &ldquo;{item.comment}&rdquo;
                  </p>
                </div>
              ))}
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}